import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3afb1541"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "font-weight-semibold my-5" }, "Registro de Vendedor")
], -1))
const _hoisted_4 = { class: "col-12 col-md-10 offset-md-1" }
const _hoisted_5 = { class: "card" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "circle-number" }, "1"),
  /*#__PURE__*/_createTextVNode(" Información del vendedor ")
], -1))
const _hoisted_7 = { class: "card-body" }
const _hoisted_8 = { class: "row row-cols-1 row-cols-md-2" }
const _hoisted_9 = { class: "col form-group mb-4" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "name",
  class: "d-flex align-items-center"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "material-icons small text-lightgray mr-1" }, "person"),
  /*#__PURE__*/_createTextVNode(" Nombres:")
], -1))
const _hoisted_11 = { class: "col form-group mb-4" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "surname",
  class: "d-flex align-items-center"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "material-icons small text-lightgray mr-1" }, "person_add"),
  /*#__PURE__*/_createTextVNode(" Apellidos:")
], -1))
const _hoisted_13 = { class: "col form-group mb-4" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "phone",
  class: "d-flex align-items-center"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "material-icons small text-lightgray mr-1" }, "phone"),
  /*#__PURE__*/_createTextVNode(" Teléfono:")
], -1))
const _hoisted_15 = { class: "col form-group mb-4" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "email",
  class: "d-flex align-items-center"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "material-icons small text-lightgray mr-1" }, "email"),
  /*#__PURE__*/_createTextVNode(" Correo electrónico:")
], -1))
const _hoisted_17 = { class: "col form-group mb-4" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "password",
  class: "d-flex align-items-center"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "material-icons small text-lightgray mr-1" }, "lock"),
  /*#__PURE__*/_createTextVNode(" Contraseña:")
], -1))
const _hoisted_19 = { class: "col form-group mb-4" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "confirmed_password",
  class: "d-flex align-items-center"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "material-icons small text-lightgray mr-1" }, "lock"),
  /*#__PURE__*/_createTextVNode(" Confirmar contraseña:")
], -1))
const _hoisted_21 = {
  key: 0,
  class: "text-danger small"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_23 = { class: "card" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "circle-number" }, "2"),
  /*#__PURE__*/_createTextVNode(" ¿Qué requisitos debes cumplir para ser parte de Iwari? ")
], -1))
const _hoisted_25 = { class: "card-body" }
const _hoisted_26 = { class: "row" }
const _hoisted_27 = { class: "col-6" }
const _hoisted_28 = { class: "d-flex mb-4" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label ml-1",
  for: "legallyConstitutedCompany"
}, "Empresa legalmente constituída", -1))
const _hoisted_30 = { class: "d-flex mb-4" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label ml-1",
  for: "locatedInLimaOrCallao"
}, "Tener bodega ubicada en Lima o Callao.", -1))
const _hoisted_32 = { class: "d-flex mb-4" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label ml-1",
  for: "abilityToAcceptReturnsAndWarranties"
}, "Capacidad para aceptar devoluciones y manejar garantías de mis productos.", -1))
const _hoisted_34 = { class: "col-6" }
const _hoisted_35 = { class: "d-flex mb-4" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label ml-1",
  for: "refurbishedLegalProducts"
}, "Productos legales, originales, genéricos y/o reacondicionados.", -1))
const _hoisted_37 = { class: "d-flex mb-4" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label ml-1",
  for: "useAutomaticGuides"
}, "Utilizar guías automáticas para entregar mis productos.", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_40 = { class: "card" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "circle-number" }, "3"),
  /*#__PURE__*/_createTextVNode(" Representación de marcas ")
], -1))
const _hoisted_42 = { class: "card-body" }
const _hoisted_43 = { class: "row" }
const _hoisted_44 = { class: "col-6" }
const _hoisted_45 = { class: "col form-group mb-4" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "categoryOfMostOfYourProducts",
  class: "d-flex align-items-center"
}, "Indícanos a que categoría pertenecen la mayoría de tus productos *", -1))
const _hoisted_47 = ["value"]
const _hoisted_48 = { class: "col form-group mb-4" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "firstMajorBrand",
  class: "d-flex align-items-center"
}, "Indícanos la primera marca principal que deseas vender en Linio *", -1))
const _hoisted_50 = { class: "col-6" }
const _hoisted_51 = { class: "col form-group mb-4" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "secondCategoryOfMostOfYourProducts",
  class: "d-flex align-items-center"
}, "En caso de tener una segunda categoría, indícanos cuál", -1))
const _hoisted_53 = ["value"]
const _hoisted_54 = { class: "col form-group mb-4" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "secondMajorBrand",
  class: "d-flex align-items-center"
}, "Indícanos la segunda marca principal que deseas vender en Linio", -1))
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_57 = { class: "card" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "circle-number" }, "4"),
  /*#__PURE__*/_createTextVNode(" Información de la empresa ")
], -1))
const _hoisted_59 = { class: "card-body" }
const _hoisted_60 = { class: "row" }
const _hoisted_61 = { class: "col-6" }
const _hoisted_62 = { class: "col form-group mb-4" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "kindOfSociety",
  class: "d-flex align-items-center"
}, "Tipo de sociedad *", -1))
const _hoisted_64 = ["value"]
const _hoisted_65 = { class: "col form-group mb-4" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "businessName",
  class: "d-flex align-items-center"
}, "Razón Social *", -1))
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", {
  id: "businessNameHelp",
  class: "form-text text-muted"
}, "Colocar el nombre legal tal cual aparece en la SUNAT", -1))
const _hoisted_68 = { class: "col form-group mb-4" }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "postalCode",
  class: "d-flex align-items-center"
}, "Código postal *", -1))
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", {
  id: "postalCodeHelp",
  class: "form-text text-muted"
}, [
  /*#__PURE__*/_createTextVNode(" 5 dígitos numéricos. Ej: 07001. Consulta tu código postal  "),
  /*#__PURE__*/_createElementVNode("a", { href: "http://www.codigopostal.gob.pe/pages/invitado/consulta.jsf" }, "aquí")
], -1))
const _hoisted_71 = { class: "col form-group mb-4" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "companyInformationCountry",
  class: "d-flex align-items-center"
}, "País *", -1))
const _hoisted_73 = ["value"]
const _hoisted_74 = { class: "col form-group mb-4" }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "companyInformationDistrict",
  class: "d-flex align-items-center"
}, "Distrito", -1))
const _hoisted_76 = { class: "col form-group mb-4" }
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "companyInformationCity",
  class: "d-flex align-items-center"
}, "Ciudad *", -1))
const _hoisted_78 = { class: "col form-group mb-4" }
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "companyInformationAddress",
  class: "d-flex align-items-center"
}, "Dirección *", -1))
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", {
  id: "companyInformationAddressHelp",
  class: "form-text text-muted"
}, "Domicilio fiscal de la razón social.", -1))
const _hoisted_81 = { class: "col-6" }
const _hoisted_82 = { class: "col form-group mb-4" }
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "fullNameOfTheLegalRepresentative",
  class: "d-flex align-items-center"
}, "Nombre completo del representante legal *", -1))
const _hoisted_84 = { class: "col form-group mb-4" }
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "companyInformationRuc",
  class: "d-flex align-items-center"
}, "RUC *", -1))
const _hoisted_86 = { class: "form-group mb-4" }
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "companyInformationRucFile" }, "Ficha RUC completa *", -1))
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", {
  id: "companyInformationRucFileHelp",
  class: "form-text text-muted"
}, "Con representante legal y dirección visible. Vigencia del documento menor a 30 días.", -1))
const _hoisted_89 = { class: "form-group mb-4" }
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "companyInformationDniFile" }, "DNI vigente del representante legal *", -1))
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", {
  id: "companyInformationDniFileHelp",
  class: "form-text text-muted"
}, "Por las dos caras, debe coincidir con la información de la Ficha RUC", -1))
const _hoisted_92 = { class: "form-group mb-4" }
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "billOfSaleFile" }, "Guía de Remisión o Boleta de Venta *", -1))
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", {
  id: "billOfSaleFileHelp",
  class: "form-text text-muted"
}, "Debe tener visible la dirección de despacho. También aceptamos la guía de remisión o boleta de venta electrónica", -1))
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_96 = { class: "card" }
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "circle-number" }, "5"),
  /*#__PURE__*/_createTextVNode(" Datos bancarios ")
], -1))
const _hoisted_98 = { class: "card-body" }
const _hoisted_99 = { class: "row" }
const _hoisted_100 = { class: "col-6" }
const _hoisted_101 = { class: "col form-group mb-4" }
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "accountHolder",
  class: "d-flex align-items-center"
}, "Titular de la Cuenta (Debe coincidir con la persona física o jurídica) *", -1))
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", {
  id: "accountHolderHelp",
  class: "form-text text-muted"
}, "(Debe coincidir con la persona física o jurídica)", -1))
const _hoisted_104 = { class: "col form-group mb-4" }
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "bank",
  class: "d-flex align-items-center"
}, "Banco *", -1))
const _hoisted_106 = ["value"]
const _hoisted_107 = { class: "col form-group mb-4" }
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "interbankAccountCode",
  class: "d-flex align-items-center"
}, "Código de Cuenta Interbancario *", -1))
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", {
  id: "interbankAccountCodeHelp",
  class: "form-text text-muted"
}, "Todos los dígitos de tu CCI (preferiblemente sin guiones)", -1))
const _hoisted_110 = { class: "col form-group mb-4" }
const _hoisted_111 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "bankDocumentFile" }, "Documento bancario *", -1))
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", {
  id: "bankDocumentFileHelp",
  class: "form-text text-muted"
}, "Referencia bancaria (firmada y sellada por la institución) o estado de cuenta bancario. El documento adjunto debe tener Código de Cuenta Interbancario visible, razón social, fecha legible y estar emitido hace menos de tres meses. También funcionaría la constancia actualizada de apertura de cuenta y que contenga el CCI", -1))
const _hoisted_113 = { class: "col-6" }
const _hoisted_114 = { class: "col form-group mb-4" }
const _hoisted_115 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "accountNumber",
  class: "d-flex align-items-center"
}, "Número de Cuenta (en Soles) *", -1))
const _hoisted_116 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", {
  id: "accountNumberHelp",
  class: "form-text text-muted"
}, "(Si no lo conoces pregunta a tu Banco, de ello dependen tus PAGOS)", -1))
const _hoisted_117 = { class: "col form-group mb-4" }
const _hoisted_118 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "accountType",
  class: "d-flex align-items-center"
}, "Tipo de Cuenta *", -1))
const _hoisted_119 = { class: "col form-group mb-4" }
const _hoisted_120 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "dniOrRucOfTheAccountHolder",
  class: "d-flex align-items-center"
}, "DNI o RUC del titular de la cuenta", -1))
const _hoisted_121 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_122 = { class: "card" }
const _hoisted_123 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "circle-number" }, "6"),
  /*#__PURE__*/_createTextVNode(" Contactos de almacén ")
], -1))
const _hoisted_124 = { class: "card-body" }
const _hoisted_125 = { class: "row" }
const _hoisted_126 = { class: "col-6" }
const _hoisted_127 = { class: "col form-group mb-4" }
const _hoisted_128 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "contactPerson",
  class: "d-flex align-items-center"
}, "Persona de contacto *", -1))
const _hoisted_129 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", {
  id: "contactPersonHelp",
  class: "form-text text-muted"
}, "Nombre y apellidos de quien se ocupará de despachar los pedidos", -1))
const _hoisted_130 = { class: "col form-group mb-4" }
const _hoisted_131 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "placeNumber",
  class: "d-flex align-items-center"
}, "Número (del lugar, interior, departamento, etc) *", -1))
const _hoisted_132 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", {
  id: "placeNumberHelp",
  class: "form-text text-muted"
}, "Sólo números. Ej: 3455", -1))
const _hoisted_133 = { class: "col form-group mb-4" }
const _hoisted_134 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "warehouseContactsDistrict",
  class: "d-flex align-items-center"
}, "Distrito en el cual se encuentra tu almacén", -1))
const _hoisted_135 = { class: "col form-group mb-4" }
const _hoisted_136 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "warehouseContactsCity",
  class: "d-flex align-items-center"
}, "Ciudad (Por ahora, sólo aceptamos registros de Lima y Callao) *", -1))
const _hoisted_137 = ["value"]
const _hoisted_138 = { class: "col form-group mb-4" }
const _hoisted_139 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "warehouseContactsPostalCode",
  class: "d-flex align-items-center"
}, "Código postal *", -1))
const _hoisted_140 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", {
  id: "warehouseContactsPostalCodeHelp",
  class: "form-text text-muted"
}, [
  /*#__PURE__*/_createTextVNode(" 5 dígitos numéricos. Ej: 07001. Consulta tu código postal  "),
  /*#__PURE__*/_createElementVNode("a", { href: "http://www.codigopostal.gob.pe/pages/invitado/consulta.jsf" }, "aquí")
], -1))
const _hoisted_141 = { class: "col-6" }
const _hoisted_142 = { class: "col form-group mb-4" }
const _hoisted_143 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "warehouseContactsStreet",
  class: "d-flex align-items-center"
}, "Calle, avenida o Jirón en que se encuentra tu almacén *", -1))
const _hoisted_144 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", {
  id: "warehouseContactsStreetHelp",
  class: "form-text text-muted"
}, "Dirección desde la cual despacharás tus productos", -1))
const _hoisted_145 = { class: "col form-group mb-4" }
const _hoisted_146 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "warehouseContactsUrbanization",
  class: "d-flex align-items-center"
}, "Urbanización en la que se encuentra tu almacén *", -1))
const _hoisted_147 = { class: "col form-group mb-4" }
const _hoisted_148 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "referencePointOfYourWarehouse",
  class: "d-flex align-items-center"
}, "Calle, avenida o Jirón en que se encuentra tu almacén *", -1))
const _hoisted_149 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", {
  id: "referencePointOfYourWarehouseHelp",
  class: "form-text text-muted"
}, "Ayúdanos a ubicar tu almacén cuando Linio vaya a buscar tus productos para entregarlos.", -1))
const _hoisted_150 = { class: "col form-group mb-4" }
const _hoisted_151 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "warehouseContactsPhone",
  class: "d-flex align-items-center"
}, "Teléfono (separa el número de área con un guión): *", -1))
const _hoisted_152 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", {
  id: "warehouseContactsPhoneHelp",
  class: "form-text text-muted"
}, "Cod.País – Teléfono. Ej: 51 - 1 333 44 44", -1))
const _hoisted_153 = { class: "col form-group mb-4" }
const _hoisted_154 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "warehouseContactsEmail",
  class: "d-flex align-items-center"
}, "Email para tramitar garantías *", -1))
const _hoisted_155 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_156 = { class: "card" }
const _hoisted_157 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "circle-number" }, "7"),
  /*#__PURE__*/_createTextVNode(" Términos y Condiciones ")
], -1))
const _hoisted_158 = { class: "card-body" }
const _hoisted_159 = { class: "mb-2" }
const _hoisted_160 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label ml-1",
  for: "promotion"
}, "Autorizo recibir comunicaciones promocionales y autorizo el uso de mi información para fines adicionales.", -1))
const _hoisted_161 = { class: "mb-4" }
const _hoisted_162 = {
  class: "form-check-label ml-1",
  for: "privacy"
}
const _hoisted_163 = /*#__PURE__*/_createTextVNode("Declaro que he leído y acepto las ")
const _hoisted_164 = /*#__PURE__*/_createTextVNode("Políticas de privacidad")
const _hoisted_165 = /*#__PURE__*/_createTextVNode(" y los ")
const _hoisted_166 = /*#__PURE__*/_createTextVNode("Términos y condiciones")
const _hoisted_167 = /*#__PURE__*/_createTextVNode(".")
const _hoisted_168 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_169 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  name: "create",
  class: "btn btn-primary btn-rounded w-100"
}, "Completar registro", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("form", {
          onSubmit: _cache[46] || (_cache[46] = 
//@ts-ignore
(...args) => (_ctx.submitRegister && _ctx.submitRegister(...args))),
          class: "mb-5",
          action: "/",
          method: "post"
        }, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.name) = $event)),
                    name: "name",
                    id: "name",
                    type: "text",
                    class: "form-control",
                    autocomplete: "off",
                    required: ""
                  }, null, 512), [
                    [_vModelText, _ctx.name]
                  ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.surname) = $event)),
                    name: "attr[surname]",
                    id: "surname",
                    type: "text",
                    class: "form-control",
                    autocomplete: "off",
                    required: ""
                  }, null, 512), [
                    [_vModelText, _ctx.surname]
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.phone) = $event)),
                    name: "attr[phone]",
                    id: "phone",
                    type: "text",
                    class: "form-control",
                    autocomplete: "off"
                  }, null, 512), [
                    [_vModelText, _ctx.phone]
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _hoisted_16,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.email) = $event)),
                    name: "email",
                    id: "email",
                    type: "email",
                    class: "form-control",
                    autocomplete: "off",
                    required: ""
                  }, null, 512), [
                    [_vModelText, _ctx.email]
                  ])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _hoisted_18,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.password) = $event)),
                    name: "password",
                    id: "password",
                    type: "password",
                    class: "form-control",
                    autocomplete: "off",
                    required: ""
                  }, null, 512), [
                    [_vModelText, _ctx.password]
                  ])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _hoisted_20,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.passwordConfirm) = $event)),
                    name: "confirmed_password",
                    id: "confirmed_password",
                    type: "password",
                    class: "form-control",
                    autocomplete: "off",
                    required: ""
                  }, null, 512), [
                    [_vModelText, _ctx.passwordConfirm]
                  ]),
                  (_ctx.messagePassword !== '')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_ctx.messagePassword), 1))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]),
          _hoisted_22,
          _createElementVNode("div", _hoisted_23, [
            _hoisted_24,
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.attributes.legallyConstitutedCompany) = $event)),
                      type: "checkbox",
                      value: "1",
                      id: "legallyConstitutedCompany",
                      name: "attr[legallyConstitutedCompany]",
                      class: "mt-1"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.attributes.legallyConstitutedCompany]
                    ]),
                    _hoisted_29
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.attributes.locatedInLimaOrCallao) = $event)),
                      type: "checkbox",
                      value: "1",
                      id: "locatedInLimaOrCallao",
                      name: "attr[locatedInLimaOrCallao]",
                      class: "mt-1"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.attributes.locatedInLimaOrCallao]
                    ]),
                    _hoisted_31
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.attributes.abilityToAcceptReturnsAndWarranties) = $event)),
                      type: "checkbox",
                      value: "1",
                      id: "abilityToAcceptReturnsAndWarranties",
                      name: "attr[abilityToAcceptReturnsAndWarranties]",
                      class: "mt-1"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.attributes.abilityToAcceptReturnsAndWarranties]
                    ]),
                    _hoisted_33
                  ])
                ]),
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("div", _hoisted_35, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.attributes.refurbishedLegalProducts) = $event)),
                      type: "checkbox",
                      value: "1",
                      id: "refurbishedLegalProducts",
                      name: "attr[refurbishedLegalProducts]",
                      class: "mt-1"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.attributes.refurbishedLegalProducts]
                    ]),
                    _hoisted_36
                  ]),
                  _createElementVNode("div", _hoisted_37, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.attributes.useAutomaticGuides) = $event)),
                      type: "checkbox",
                      value: "1",
                      id: "useAutomaticGuides",
                      name: "attr[useAutomaticGuides]",
                      class: "mt-1"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.attributes.useAutomaticGuides]
                    ]),
                    _hoisted_38
                  ])
                ])
              ])
            ])
          ]),
          _hoisted_39,
          _createElementVNode("div", _hoisted_40, [
            _hoisted_41,
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("div", _hoisted_43, [
                _createElementVNode("div", _hoisted_44, [
                  _createElementVNode("div", _hoisted_45, [
                    _hoisted_46,
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.attributes.categoryOfMostOfYourProducts) = $event)),
                      name: "categoryOfMostOfYourProducts",
                      id: "categoryOfMostOfYourProducts",
                      class: "form-control custom-select",
                      required: ""
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.categoryOfMostOfYourProducts, (item) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: item,
                          value: item.value
                        }, _toDisplayString(item.name), 9, _hoisted_47))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _ctx.attributes.categoryOfMostOfYourProducts]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_48, [
                    _hoisted_49,
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.attributes.firstMajorBrand) = $event)),
                      name: "firstMajorBrand",
                      id: "firstMajorBrand",
                      type: "text",
                      class: "form-control",
                      autocomplete: "off",
                      required: ""
                    }, null, 512), [
                      [_vModelText, _ctx.attributes.firstMajorBrand]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_50, [
                  _createElementVNode("div", _hoisted_51, [
                    _hoisted_52,
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.attributes.secondCategoryOfMostOfYourProducts) = $event)),
                      name: "secondCategoryOfMostOfYourProducts",
                      id: "secondCategoryOfMostOfYourProducts",
                      class: "form-control custom-select"
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.categoryOfMostOfYourProducts, (item) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: item,
                          value: item.value
                        }, _toDisplayString(item.name), 9, _hoisted_53))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _ctx.attributes.secondCategoryOfMostOfYourProducts]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_54, [
                    _hoisted_55,
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.attributes.secondMajorBrand) = $event)),
                      name: "secondMajorBrand",
                      id: "secondMajorBrand",
                      type: "text",
                      class: "form-control",
                      autocomplete: "off"
                    }, null, 512), [
                      [_vModelText, _ctx.attributes.secondMajorBrand]
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _hoisted_56,
          _createElementVNode("div", _hoisted_57, [
            _hoisted_58,
            _createElementVNode("div", _hoisted_59, [
              _createElementVNode("div", _hoisted_60, [
                _createElementVNode("div", _hoisted_61, [
                  _createElementVNode("div", _hoisted_62, [
                    _hoisted_63,
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.attributes.kindOfSociety) = $event)),
                      name: "kindOfSociety",
                      id: "kindOfSociety",
                      class: "form-control custom-select",
                      required: ""
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.kindOfSocieties, (item) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: item,
                          value: item.value
                        }, _toDisplayString(item.name), 9, _hoisted_64))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _ctx.attributes.kindOfSociety]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_65, [
                    _hoisted_66,
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.attributes.businessName) = $event)),
                      name: "businessName",
                      id: "businessName",
                      type: "text",
                      class: "form-control",
                      autocomplete: "off",
                      required: ""
                    }, null, 512), [
                      [_vModelText, _ctx.attributes.businessName]
                    ]),
                    _hoisted_67
                  ]),
                  _createElementVNode("div", _hoisted_68, [
                    _hoisted_69,
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.attributes.postalCode) = $event)),
                      name: "postalCode",
                      id: "postalCode",
                      type: "number",
                      class: "form-control",
                      autocomplete: "off",
                      required: ""
                    }, null, 512), [
                      [_vModelText, _ctx.attributes.postalCode]
                    ]),
                    _hoisted_70
                  ]),
                  _createElementVNode("div", _hoisted_71, [
                    _hoisted_72,
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.attributes.companyInformationCountry) = $event)),
                      name: "companyInformationCountry",
                      id: "companyInformationCountry",
                      class: "form-control custom-select",
                      required: ""
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.countries, (item) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: item,
                          value: item.value
                        }, _toDisplayString(item.name), 9, _hoisted_73))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _ctx.attributes.companyInformationCountry]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_74, [
                    _hoisted_75,
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.attributes.companyInformationDistrict) = $event)),
                      name: "companyInformationDistrict",
                      id: "companyInformationDistrict",
                      type: "text",
                      class: "form-control",
                      autocomplete: "off"
                    }, null, 512), [
                      [_vModelText, _ctx.attributes.companyInformationDistrict]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_76, [
                    _hoisted_77,
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.attributes.companyInformationCity) = $event)),
                      name: "companyInformationCity",
                      id: "companyInformationCity",
                      type: "text",
                      class: "form-control",
                      autocomplete: "off",
                      required: ""
                    }, null, 512), [
                      [_vModelText, _ctx.attributes.companyInformationCity]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_78, [
                    _hoisted_79,
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.attributes.companyInformationAddress) = $event)),
                      name: "companyInformationAddress",
                      id: "companyInformationAddress",
                      type: "text",
                      class: "form-control",
                      autocomplete: "off",
                      required: ""
                    }, null, 512), [
                      [_vModelText, _ctx.attributes.companyInformationAddress]
                    ]),
                    _hoisted_80
                  ])
                ]),
                _createElementVNode("div", _hoisted_81, [
                  _createElementVNode("div", _hoisted_82, [
                    _hoisted_83,
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.attributes.fullNameOfTheLegalRepresentative) = $event)),
                      name: "fullNameOfTheLegalRepresentative",
                      id: "fullNameOfTheLegalRepresentative",
                      type: "text",
                      class: "form-control",
                      autocomplete: "off",
                      required: ""
                    }, null, 512), [
                      [_vModelText, _ctx.attributes.fullNameOfTheLegalRepresentative]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_84, [
                    _hoisted_85,
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.attributes.companyInformationRuc) = $event)),
                      name: "companyInformationRuc",
                      id: "companyInformationRuc",
                      type: "text",
                      class: "form-control",
                      autocomplete: "off",
                      required: ""
                    }, null, 512), [
                      [_vModelText, _ctx.attributes.companyInformationRuc]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_86, [
                    _hoisted_87,
                    _createElementVNode("input", {
                      onChange: _cache[24] || (_cache[24] = ($event: any) => (_ctx.onFileRuc(this))),
                      ref: "companyInformationRucFile",
                      type: "file",
                      class: "form-control-file",
                      id: "companyInformationRucFile",
                      name: "companyInformationRucFile",
                      required: ""
                    }, null, 544),
                    _hoisted_88
                  ]),
                  _createElementVNode("div", _hoisted_89, [
                    _hoisted_90,
                    _createElementVNode("input", {
                      onChange: _cache[25] || (_cache[25] = ($event: any) => (_ctx.onFileDni(this))),
                      ref: "companyInformationDniFile",
                      type: "file",
                      class: "form-control-file",
                      id: "companyInformationDniFile",
                      name: "companyInformationDniFile",
                      required: ""
                    }, null, 544),
                    _hoisted_91
                  ]),
                  _createElementVNode("div", _hoisted_92, [
                    _hoisted_93,
                    _createElementVNode("input", {
                      onChange: _cache[26] || (_cache[26] = ($event: any) => (_ctx.onFileBillOfSale(this))),
                      ref: "billOfSaleFile",
                      type: "file",
                      class: "form-control-file",
                      id: "billOfSaleFile",
                      name: "billOfSaleFile",
                      required: ""
                    }, null, 544),
                    _hoisted_94
                  ])
                ])
              ])
            ])
          ]),
          _hoisted_95,
          _createElementVNode("div", _hoisted_96, [
            _hoisted_97,
            _createElementVNode("div", _hoisted_98, [
              _createElementVNode("div", _hoisted_99, [
                _createElementVNode("div", _hoisted_100, [
                  _createElementVNode("div", _hoisted_101, [
                    _hoisted_102,
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.attributes.accountHolder) = $event)),
                      name: "accountHolder",
                      id: "accountHolder",
                      type: "text",
                      class: "form-control",
                      autocomplete: "off",
                      required: ""
                    }, null, 512), [
                      [_vModelText, _ctx.attributes.accountHolder]
                    ]),
                    _hoisted_103
                  ]),
                  _createElementVNode("div", _hoisted_104, [
                    _hoisted_105,
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.attributes.bank) = $event)),
                      name: "bank",
                      id: "bank",
                      class: "form-control custom-select",
                      required: ""
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.banks, (item) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: item,
                          value: item.value
                        }, _toDisplayString(item.name), 9, _hoisted_106))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _ctx.attributes.bank]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_107, [
                    _hoisted_108,
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.attributes.interbankAccountCode) = $event)),
                      name: "interbankAccountCode",
                      id: "interbankAccountCode",
                      type: "text",
                      class: "form-control",
                      autocomplete: "off",
                      required: ""
                    }, null, 512), [
                      [_vModelText, _ctx.attributes.interbankAccountCode]
                    ]),
                    _hoisted_109
                  ]),
                  _createElementVNode("div", _hoisted_110, [
                    _hoisted_111,
                    _createElementVNode("input", {
                      onChange: _cache[30] || (_cache[30] = ($event: any) => (_ctx.onFileBankDocument(this))),
                      ref: "bankDocumentFile",
                      type: "file",
                      class: "form-control-file",
                      id: "bankDocumentFile",
                      name: "bankDocumentFile",
                      required: ""
                    }, null, 544),
                    _hoisted_112
                  ])
                ]),
                _createElementVNode("div", _hoisted_113, [
                  _createElementVNode("div", _hoisted_114, [
                    _hoisted_115,
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.attributes.accountNumber) = $event)),
                      name: "accountNumber",
                      id: "accountNumber",
                      type: "text",
                      class: "form-control",
                      autocomplete: "off",
                      required: ""
                    }, null, 512), [
                      [_vModelText, _ctx.attributes.accountNumber]
                    ]),
                    _hoisted_116
                  ]),
                  _createElementVNode("div", _hoisted_117, [
                    _hoisted_118,
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.attributes.accountType) = $event)),
                      name: "accountType",
                      id: "accountType",
                      type: "text",
                      class: "form-control",
                      autocomplete: "off",
                      required: ""
                    }, null, 512), [
                      [_vModelText, _ctx.attributes.accountType]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_119, [
                    _hoisted_120,
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.attributes.dniOrRucOfTheAccountHolder) = $event)),
                      name: "dniOrRucOfTheAccountHolder",
                      id: "dniOrRucOfTheAccountHolder",
                      type: "text",
                      class: "form-control",
                      autocomplete: "off"
                    }, null, 512), [
                      [_vModelText, _ctx.attributes.dniOrRucOfTheAccountHolder]
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _hoisted_121,
          _createElementVNode("div", _hoisted_122, [
            _hoisted_123,
            _createElementVNode("div", _hoisted_124, [
              _createElementVNode("div", _hoisted_125, [
                _createElementVNode("div", _hoisted_126, [
                  _createElementVNode("div", _hoisted_127, [
                    _hoisted_128,
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.attributes.contactPerson) = $event)),
                      name: "contactPerson",
                      id: "contactPerson",
                      type: "text",
                      class: "form-control",
                      autocomplete: "off",
                      required: ""
                    }, null, 512), [
                      [_vModelText, _ctx.attributes.contactPerson]
                    ]),
                    _hoisted_129
                  ]),
                  _createElementVNode("div", _hoisted_130, [
                    _hoisted_131,
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.attributes.placeNumber) = $event)),
                      name: "placeNumber",
                      id: "placeNumber",
                      type: "text",
                      class: "form-control",
                      autocomplete: "off",
                      required: ""
                    }, null, 512), [
                      [_vModelText, _ctx.attributes.placeNumber]
                    ]),
                    _hoisted_132
                  ]),
                  _createElementVNode("div", _hoisted_133, [
                    _hoisted_134,
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.attributes.warehouseContactsDistrict) = $event)),
                      name: "warehouseContactsDistrict",
                      id: "warehouseContactsDistrict",
                      type: "text",
                      class: "form-control",
                      autocomplete: "off"
                    }, null, 512), [
                      [_vModelText, _ctx.attributes.warehouseContactsDistrict]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_135, [
                    _hoisted_136,
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.attributes.warehouseContactsCity) = $event)),
                      name: "warehouseContactsCity",
                      id: "warehouseContactsCity",
                      class: "form-control custom-select",
                      required: ""
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.warehouseContactsCities, (item) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: item,
                          value: item.value
                        }, _toDisplayString(item.name), 9, _hoisted_137))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _ctx.attributes.warehouseContactsCity]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_138, [
                    _hoisted_139,
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.attributes.warehouseContactsPostalCode) = $event)),
                      name: "warehouseContactsPostalCode",
                      id: "warehouseContactsPostalCode",
                      type: "text",
                      class: "form-control",
                      autocomplete: "off",
                      required: ""
                    }, null, 512), [
                      [_vModelText, _ctx.attributes.warehouseContactsPostalCode]
                    ]),
                    _hoisted_140
                  ])
                ]),
                _createElementVNode("div", _hoisted_141, [
                  _createElementVNode("div", _hoisted_142, [
                    _hoisted_143,
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.attributes.warehouseContactsStreet) = $event)),
                      name: "warehouseContactsStreet",
                      id: "warehouseContactsStreet",
                      type: "text",
                      class: "form-control",
                      autocomplete: "off",
                      required: ""
                    }, null, 512), [
                      [_vModelText, _ctx.attributes.warehouseContactsStreet]
                    ]),
                    _hoisted_144
                  ]),
                  _createElementVNode("div", _hoisted_145, [
                    _hoisted_146,
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.attributes.warehouseContactsUrbanization) = $event)),
                      name: "warehouseContactsUrbanization",
                      id: "warehouseContactsUrbanization",
                      type: "text",
                      class: "form-control",
                      autocomplete: "off",
                      required: ""
                    }, null, 512), [
                      [_vModelText, _ctx.attributes.warehouseContactsUrbanization]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_147, [
                    _hoisted_148,
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.attributes.referencePointOfYourWarehouse) = $event)),
                      name: "referencePointOfYourWarehouse",
                      id: "referencePointOfYourWarehouse",
                      type: "text",
                      class: "form-control",
                      autocomplete: "off",
                      required: ""
                    }, null, 512), [
                      [_vModelText, _ctx.attributes.referencePointOfYourWarehouse]
                    ]),
                    _hoisted_149
                  ]),
                  _createElementVNode("div", _hoisted_150, [
                    _hoisted_151,
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.attributes.warehouseContactsPhone) = $event)),
                      name: "warehouseContactsPhone",
                      id: "warehouseContactsPhone",
                      type: "text",
                      class: "form-control",
                      autocomplete: "off",
                      required: ""
                    }, null, 512), [
                      [_vModelText, _ctx.attributes.warehouseContactsPhone]
                    ]),
                    _hoisted_152
                  ]),
                  _createElementVNode("div", _hoisted_153, [
                    _hoisted_154,
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.attributes.warehouseContactsEmail) = $event)),
                      name: "warehouseContactsEmail",
                      id: "warehouseContactsEmail",
                      type: "text",
                      class: "form-control",
                      autocomplete: "off",
                      required: ""
                    }, null, 512), [
                      [_vModelText, _ctx.attributes.warehouseContactsEmail]
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _hoisted_155,
          _createElementVNode("div", _hoisted_156, [
            _hoisted_157,
            _createElementVNode("div", _hoisted_158, [
              _createElementVNode("div", _hoisted_159, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.checkAds) = $event)),
                  type: "checkbox",
                  value: "1",
                  id: "promotion",
                  name: "attr[ads]"
                }, null, 512), [
                  [_vModelCheckbox, _ctx.checkAds]
                ]),
                _hoisted_160
              ]),
              _createElementVNode("div", _hoisted_161, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.checkTerms) = $event)),
                  type: "checkbox",
                  value: "1",
                  id: "privacy",
                  name: "attr[accept]",
                  required: ""
                }, null, 512), [
                  [_vModelCheckbox, _ctx.checkTerms]
                ]),
                _createElementVNode("label", _hoisted_162, [
                  _hoisted_163,
                  _createVNode(_component_router_link, {
                    to: "/privacy-policy",
                    target: "_blank"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_164
                    ]),
                    _: 1
                  }),
                  _hoisted_165,
                  _createVNode(_component_router_link, {
                    to: "/terms-conditions",
                    target: "_blank"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_166
                    ]),
                    _: 1
                  }),
                  _hoisted_167
                ])
              ])
            ])
          ]),
          _hoisted_168,
          _hoisted_169
        ], 32)
      ])
    ])
  ]))
}